import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

export interface AssetInventoryGroup {
  id: string;
  asset_name: string;
  location_id: string | null;
  location_name: string;
  location_path: string;
  lin: string | null;
  nsn: string | null;
  status_key: string | null;
  is_true_location: boolean;
  stock_quantity: number;
  asset_ids: string[];
  catalog_id: string | null;
  catalog_type: string | null;
  has_catalog_image: boolean;
}

export const useAssetInventory = (filters?: Record<string, string>) => {
  return useQuery({
    queryKey: ['asset-inventory', filters],
    queryFn: async (): Promise<AssetInventoryGroup[]> => {
      const params = new URLSearchParams();

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value) {
            params.append(key, value);
          }
        });
      }

      const queryString = params.toString();
      const endpoint = `/api/rest/data/v1/asset_inventory_summary${queryString ? `?${queryString}` : ''}`;

      return httpClient.get<AssetInventoryGroup[]>(endpoint);
    },
  });
};
